import { FC } from 'react'
import cn from 'classnames'

import styles from './styles.module.scss'
import mapFiltersName from './utils'
import { useTranslation } from 'utils/use-translation'

export type Filter = any

interface Props {
  filters: Filter[]
  selectedFilters: Filter[]
  onSelect: (filter: Filter | Filter[]) => void
}

export const FilterList: FC<Props> = ({ filters, selectedFilters, onSelect }) => {
  const { t } = useTranslation()

  return (
    <div className={cn(styles.container)}>
      <div className={styles.list}>
        {filters.map((cur) => (
          <label className={styles.listItem} key={cur}>
            <input type="checkbox" checked={selectedFilters.includes(cur)} onChange={() => onSelect(cur)} />
            <p>{t(mapFiltersName(cur.toLowerCase()))}</p>
          </label>
        ))}
      </div>
    </div>
  )
}
